export enum IdentifierType {
  Document = 'Document',
  EMAIL = 'Email',
  PHONE_NUMBER = 'PhoneNumber',
  RandomKey = 'RandomKey'
}

export interface VerifyAccountRequest {
  identifierType: IdentifierType;
  identifier: string;
}

export interface VerifyAccountResponse {
  exists: boolean;
  accountId?: string;
}
